import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { REQUEST_TYPES_ID as RequestType, RAISE_REQUEST_ORDER_BASE } from '../../../../constants/external-constants';
import { EXHIBIT_TYPE as EXHIBITTYPE } from '../../../../utils/constant.utils';
//import Translation from '../../../translation/translation.component';
import { ORFCheckbox, ORFSearchSuggestions as SearchSuggestions } from '../../../common/forms/order-request-form.component';
import { createRequestActions, findROBEmployee } from "./../../../../store/external/request-reducer/create-request.reducer";
//wireless actions
import { newMobileSubscriptionActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer";
import { wirelessChangePricePlanActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-price-plan.reducer";
import { wirelessChangUserActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-user.reducer";
import { wirelessChangeVendorActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-change-vendor.reducer";
import { wirelessReplaceSimActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-sim.reducer";
import { wirelessTerminateActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-terminate-subscription.reducer";
import { wirelessPortInActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-port-in.reducer";
import { wirelessPortOutActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-portout.reducer";
import { wirelessAccessoryActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-accessory.reducer";
import { wirelessOtherActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-other.reducer";
import { wirelessReplaceDeviceActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-replace-device.reducer";
import { wirelessIntlRoamingAccessActions } from "../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-intl-roaming-access.reducer"

//wireline actions
import { newCircuitSubscriptionActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-subscription.reducer";
import { wirelineChangeVendorActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-change-vendor.reducer";
import { wirelineTerminateCircuitActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate-circuit.reducer";
import { wirelineTerminateExhibitBActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-terminate/wireline-terminate-exhibit-b.reducer";
import { wirelineUpgradeCircuitActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-upgrade-circuit.reducer";
import { newQuotationActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer";
import { wirelineOtherRequestActions } from "./../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-other-request.reducer";
import Translation from "../../../common/translation/translation.component";
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import { withRouter } from 'react-router-dom';
import { ConfirmationModal } from "../../../../components/common/modal/modal.component";
import { requestDetailsActions } from "./../../../../store/external/request-reducer/request-details.reducer";
import { fileAttachmentActions } from '../../../../store/external/common-reducer/file-attachment.reducer';

class RequestOnBehalf extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isROBEnable: false
            , error: false
            , inputOnce: false
            , searchKey: ''
        };

        this.SearchSuggestions = React.createRef();
        this.ConfirmationModal = React.createRef();
        this.ROBCheckbox = React.createRef();
    }

    componentDidMount() {
        const { selectedUser } = this.props.sideNavMenu;
        const { approverData, selectedItem, requestData } = this.props.requestDetail;
        const { isUpdateRequest, requestTypeId } = this.props.createRequest;
        const { RequestedInBeHalfOf } = this.props.requestDetail.requestData;
        const isChangeUser = requestTypeId === RequestType.changeUser;
        if (isUpdateRequest && isChangeUser) {
            const requestOnBehalfName = RequestedInBeHalfOf?.Name?.trim();

            if (requestOnBehalfName) {
                this.props.setRequestOnBehalfUser(requestOnBehalfName, RequestedInBeHalfOf?.EmployeeId);
                this.ROBCheckbox.current.setChecked(true);
                this.SearchSuggestions.current.onChange(null, { newValue: requestOnBehalfName });
            }
        }
        else if (isUpdateRequest && requestData?.Order?.IsRequestedInBehalf && (selectedItem.IsRequestor || selectedItem.IsOwner)) {
            const requestOnBehalfName = RequestedInBeHalfOf.Name?.trim();
            this.props.setRequestOnBehalfUser(requestOnBehalfName, RequestedInBeHalfOf?.EmployeeId);
            this.ROBCheckbox.current.setChecked(true);
            this.SearchSuggestions.current.onChange(null, { newValue: requestOnBehalfName })
        }
        else if (selectedUser.EmployeeId > 0) {
            var robData = {
                EmployeeId: selectedUser.EmployeeId
                , Name: selectedUser.FullName              
                , LastFirstName: selectedUser.FullName?.trim()
                , EmailAddress: selectedUser.EmailAddress
                , ContactNumber: selectedUser.ContactNumber
                , Country: selectedUser.Country
                , Location: selectedUser.Location
                , LocationSiteCityCountry: selectedUser.LocationSiteCityCountry
                , Vip: selectedUser.Vip
            };
            this.showAutoSuggestion(true, robData);
            this.loadSelectedUserROBDetails(selectedUser);
        }
    }
        
    loadSelectedUserROBDetails = async (selectedUser) => {
        const { setRequestOnBehalfUser, fetchWorkFlowApproverDetails } = this.props;
        const requestOnBehalfName = selectedUser.FullName?.trim();

        if (requestOnBehalfName) {
            await setRequestOnBehalfUser(requestOnBehalfName, selectedUser.EmployeeId);
        }
        fetchWorkFlowApproverDetails(selectedUser.EmployeeId, true);
    }

    componentWillUnmount() {
        this.props.setIsRequestOnBehalf(false);
        this.props.setIsRequestBehalfToggle(false);
    }

    displayReminder = (typeId) => {

        switch (typeId) {
            case RequestType.simAndDevice:
            case RequestType.newMobileDevice:
            case RequestType.wifiDongleAndDataCard:
            case RequestType.simAndDeviceBSA:
            case RequestType.simOnlyBSA:
            case RequestType.multiSIMBSA:
            case RequestType.wifiDongleAndDataCardBIN:
            case RequestType.voiceSIMBIN:
            case RequestType.wifiDongleDataCardAndVoiceSIMBIN:
            case RequestType.newMobile:
                return (
                    <div className="request-subscription-detail-header">
                        <span><Translation translationKey="new_mobile_reminder_updated" /> </span>
                        <span className="cursor-pointer d-inline-block request-subscription-detail-link" onClick={() => this.showDiscardConfirmationModal()}><Translation translationKey="Port_in_Text" /></span>
                        <span> <Translation translationKey="port_out_instead" /></span>
                    </div>);

            case RequestType.portIn:
                return (
                    <div className="request-subscription-detail-header">
                        <span><Translation translationKey="port_in_reminder" /> </span>
                        <span className="cursor-pointer d-inline-block request-subscription-detail-link" onClick={() => this.showDiscardConfirmationModal()}><Translation translationKey="New_Subs_Text" /></span>
                        <span> <Translation translationKey="port_out_instead" /></span>
                    </div>);
            default:
        }
    };

    showAutoSuggestion = (checked, robData) => {
        this.resetRequestForm();
        this.props.resetSubscriptList();
        this.props.setIsRequestOnBehalf(checked, robData);
        this.props.setIsRequestBehalfToggle(true);
        if (!checked) {
            this.setState({ searchKey: Date.now() }, () => { this.SearchSuggestions.current.onChangeSuggestion(null, { newValue: '' });})
        }
    }

    onChangeROBSelect = (value, propsName, objects) => {
        const { onRequestOnBehalfUserSelect, fetchWorkFlowApproverDetails } = this.props;
        let empId = sessionStorage.EmployeeID;

        const employees = Array.isArray(objects) ? objects : this.props.createRequest.employeeList;
        if (value) {
            const selected = findROBEmployee(employees, value);

            if (selected?.EmployeeId) {
                empId = selected.EmployeeId;
            }
        }

        onRequestOnBehalfUserSelect(value, propsName, objects);
        fetchWorkFlowApproverDetails(empId, true);
        if(value === '' || !this.state.inputOnce) {
            this.setState({ inputOnce: true }, () => this.resetRequestForm());
        }
    };

    handleFirstInput = () =>{
        this.setState({ inputOnce: false });
    }

    resetRequestForm = () => {
        switch (this.props.createRequest.requestTypeId) {
            //wireless
            case RequestType.simAndDevice:
            case RequestType.newMobileDevice:
            case RequestType.wifiDongleAndDataCard:
            case RequestType.simAndDeviceBSA:
            case RequestType.simOnlyBSA:
            case RequestType.multiSIMBSA:
            case RequestType.wifiDongleAndDataCardBIN:
            case RequestType.voiceSIMBIN:
            case RequestType.wifiDongleDataCardAndVoiceSIMBIN:
            case RequestType.newMobile:
                this.props.resetNewMobileForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.newSubscriptionWireline:
                this.props.resetNewCircuitForm();
                this.props.resetFileAttachment();
                break;
            case RequestType.changeUser:
                this.props.resetWirelessChangeUserForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.changePricePlan:
                this.props.resetWirelessChangePricePlanModel(); break;
            case RequestType.changeVendor:
                this.props.resetWirelessChangeVendorForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.simReplacement:
                this.props.resetWirelessReplaceSimForm(); break
            case RequestType.deviceReplacement:
                this.props.resetWirelessReplaceDeviceForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.terminate:
                this.props.resetWirelessTerminateForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.portIn:
                this.props.resetWirelessPortInForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.portOut:
                this.props.resetWirelessPortOutForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.otherRequestOther:
            case RequestType.other:
            case RequestType.simActivation:
            case RequestType.enableHotspot:
            case RequestType.changeNumber:
            case RequestType.pukCode:
            case RequestType.otherSIMReplacement:
            case RequestType.otherChangeOfPlan:
            case RequestType.suspendResumeService:
                this.props.resetWirelessOtherForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.accessory:
                this.props.resetWirelessAccessoryForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.subscriptionCancellation:
                this.props.resetWirelessTerminateForm({ isResetRequestOnBehalf: true }); break;
            case RequestType.intlRoamingAccess:
                this.props.resetWirelessIntlRoamingAccessForm({ isResetRequestOnBehalf: true }); break;
            //case RequestType.other: break;

            //wireline
            case RequestType.newCircuitOrder:
                this.props.resetNewCircuitForm();
                this.props.resetFileAttachment();
                break;
            case RequestType.wirelineChangeVendor:
                this.props.resetWirelineChangeVendorForm({ isResetRequestOnBehalf: true });
                this.props.resetFileAttachment();
                break;
            case RequestType.terminateSubscriptionWireline:

                const { resetWirelineTerminateCircuitForm, resetWirelineTerminateExhibitBForm, resetFileAttachment } = this.props;
                const { exhibitType } = this.props.createRequest;

                if (exhibitType == EXHIBITTYPE.exhibitA) {
                    resetWirelineTerminateCircuitForm({ isResetRequestOnBehalf: true });
                    resetFileAttachment();
                    break;

                } else if (exhibitType == EXHIBITTYPE.exhibitB) {
                    resetWirelineTerminateExhibitBForm({ isResetRequestOnBehalf: true }); break;
                } else {
                    //form = null;
                }
                break;
            case RequestType.updatePlanWireline:
                this.props.resetWirelineUpgradeCircuit({ isResetRequestOnBehalf: true }); 
                break;
            case RequestType.otherWireline:
            case RequestType.wirelineOtherOther:
            case RequestType.wirelineUpgradeCircuit:
            case RequestType.wirelineChangeLocationAddress:
                this.props.resetWirelineOtherRequestForm({ isResetRequestOnBehalf: true }); 
                break;
            case RequestType.newQuotation:
                this.props.resetQuotationForm(); break;

            default:
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    navigateTo(requestTypeId) {
        const { history, createRequest, setRequestType, typeId, updateOrderRequest } = this.props;
       
        if (typeId == RequestType.portIn || typeId == RequestType.newMobile || typeId == RequestType.simAndDevice
            || typeId == RequestType.newMobileDevice || typeId == RequestType.wifiDongleAndDataCard
            || typeId == RequestType.simAndDeviceBSA || typeId == RequestType.simOnlyBSA
            || typeId == RequestType.multiSIMBSA || typeId == RequestType.wifiDongleAndDataCardBIN
            || typeId == RequestType.voiceSIMBIN || typeId == RequestType.wifiDongleDataCardAndVoiceSIMBIN) {
            updateOrderRequest(false);

            const requestTypeName = createRequest.requestTypes.Wireless.NewRequests.find(r => r.RequestTypeID == requestTypeId)?.RequestType ?? "";
            const clearPath = this.getBasePath(history.location.pathname, "/AllRequest")
            this.props.history.goBack();

            setTimeout(() => {
                setRequestType(requestTypeId, requestTypeName);
                history.push(`${clearPath}/${RAISE_REQUEST_ORDER_BASE + requestTypeId}`);

            }, 100);
        }
    }

    showDiscardConfirmationModal = () => {
        if (this.props.typeId === RequestType.portIn) {
            this.navigateTo(RequestType.newMobile);
        }
        else if (this.props.typeId === RequestType.newMobile || this.props.typeId == RequestType.simAndDevice
            || this.props.typeId == RequestType.newMobileDevice || this.props.typeId == RequestType.wifiDongleAndDataCard
            || this.props.typeId == RequestType.simAndDeviceBSA || this.props.typeId == RequestType.simOnlyBSA
            || this.props.typeId == RequestType.multiSIMBSA || this.props.typeId == RequestType.wifiDongleAndDataCardBIN
            || this.props.typeId == RequestType.voiceSIMBIN || this.props.typeId == RequestType.wifiDongleDataCardAndVoiceSIMBIN) {
            this.navigateTo(RequestType.portIn);
        }
    };

    getBasePath = (pathname, cutoff) => {
        //"/AllRequest";
        const index = pathname.indexOf(cutoff);
    
        if (index === -1) return pathname; // fallback: return original if not found
    
        return pathname.substring(0, index + cutoff.length);
    }
    

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    handleConfirm = () => {
        this.ConfirmationModal.current.handleClose();
    }

    checkAndSetROBData = () => {
        const { requestOnBehalfData, employeeList, isUpdateRequest } = this.props.createRequest;
        let ROBDetail = '';
        if(requestOnBehalfData.Name !== undefined && requestOnBehalfData.Name !== null && requestOnBehalfData.Name !== '') {
            if (employeeList !== undefined
                && employeeList !== null
                && employeeList.length > 0) {
                if (requestOnBehalfData.Eid !== undefined) {
                    ROBDetail = `${requestOnBehalfData.Eid} | ${requestOnBehalfData.LocationSiteCityCountry}`;
                }
               
            }
            else{
                ROBDetail = `${requestOnBehalfData.EmailAddress} | ${requestOnBehalfData.LocationSiteCityCountry}`;
            }
        }
        return ROBDetail;
    }

    render() {
        const { typeId
            , disableROBCheckbox
            , fetchROBEmployeeByValue
            , withIcon
        } = this.props;
        const { selectedUser } = this.props.sideNavMenu;
        const { isRequestOnBehalf, requestOnBehalfData, employeeList, isUpdateRequest } = this.props.createRequest;
        const { selectedItem } = this.props.requestDetail;

        let disableROBforOwnerButNotRequestor = (isUpdateRequest && selectedItem?.IsRequestedInBehalf
            && (selectedItem.IsRequestor == false && selectedItem.IsOwner == true) ? true : false)

        const enableROB = selectedUser.EmployeeId != null;
        return (
            <div className="request-form-container">
                <div className="vertical-line"></div>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <div>
                            {this.displayReminder(typeId)}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} className={`${isRequestOnBehalf ? "required" : ""}`}>
                        <div>
                            <ORFCheckbox
                                ref={this.ROBCheckbox}
                                label={this.toLocaleLanguage('request_onbehalf_small')}
                                action={this.showAutoSuggestion}
                                disable={disableROBCheckbox || disableROBforOwnerButNotRequestor}
                                initialValue={enableROB}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                        <div className="mt-n13 rob-input__container">
                            <SearchSuggestions
                                key={this.state.searchKey}
                                ref={this.SearchSuggestions}
                                value={requestOnBehalfData.LastFirstName}
                                syncValue={true}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                propDisplay={'LastFirstName'}
                                options={employeeList.length > 0 ? employeeList : ''}
                                onChangeAction={this.onChangeROBSelect}
                                handleReset={this.onResetChange}
                                searchAction={fetchROBEmployeeByValue}
                                hidden={!isRequestOnBehalf}
                                disabled={disableROBCheckbox || disableROBforOwnerButNotRequestor}
                                withIcon={withIcon}
                                errorMessage={this.toLocaleLanguage('error_user_not_exist')}
                                haveError={this.haveError}
                                handleFirstInput={this.handleFirstInput}
                            />                        
                            <div className="request-details-container">
                                <span>{this.checkAndSetROBData()}</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={<Translation translationKey="discard_form" />}
                    messageBody={<Translation translationKey="are_you_sure_you_want_to_discard_this_request" />}
                    confirmAction={this.handleConfirm}
                    closeLabel={<Translation translationKey="discard_cancelBtn" />}
                    confirmLabel={<Translation translationKey="discard_confirmBtn" />}
                />
            </div>
        );
    }
};

export default withRouter(
    connect(
        state => {
            const { createRequest, sideNavMenu, translation, requestLog, requestDetail } = state;
            return {
                createRequest
                , sideNavMenu
                , ...translation
                , requestLog
                , requestDetail
            };
        }
        , dispatch =>
            bindActionCreators(
                Object.assign({}, createRequestActions
                    // wireless actions
                    , newMobileSubscriptionActions
                    , wirelessChangePricePlanActions
                    , wirelessChangUserActions
                    , wirelessChangeVendorActions
                    , wirelessReplaceSimActions
                    , wirelessTerminateActions
                    , wirelessPortInActions
                    , requestDetailsActions
                    , wirelessPortOutActions
                    , wirelessAccessoryActions
                    , wirelessOtherActions
                    , wirelessReplaceDeviceActions
                    , wirelessIntlRoamingAccessActions
                    //wireline actions
                    , newCircuitSubscriptionActions
                    , wirelineChangeVendorActions
                    , wirelineTerminateCircuitActions
                    , wirelineTerminateExhibitBActions
                    , wirelineUpgradeCircuitActions
                    , newQuotationActions
                    , wirelineOtherRequestActions
                    , requestDetailsActions
                    , fileAttachmentActions
                ),
                dispatch
            )
    )(RequestOnBehalf)
);
